export default __webpack_public_path__ + "static/media/app1-4.d012ffbe.jpg";